import { useCallback } from "react";
import {
  AnalysisCode,
  WorkOrderEvents,
} from "../../models/analysiscodes/AnalysisCodes";
import { submitCodes } from "../../api/AnalysisCodes";

export default function useSaveAnalysisCodes() {
  const saveAnalysisCodes = useCallback(
    async (codes: AnalysisCode[], workOrderEvents: WorkOrderEvents) => {
      const response = await submitCodes(codes, workOrderEvents);
      return response;
    },
    []
  );

  return { saveAnalysisCodes };
}
